import { createJSONStorage } from "jotai/utils"

const makeSafeStorage = (resolve: () => Storage | undefined): Storage => ({
	get length() {
		try {
			return resolve()?.length ?? 0
		} catch {
			return 0
		}
	},
	clear() {
		try {
			resolve()?.clear()
		} catch {
			// ignore
		}
	},
	getItem(key) {
		try {
			return resolve()?.getItem(key) ?? null
		} catch {
			return null
		}
	},
	key(index) {
		try {
			return resolve()?.key(index) ?? null
		} catch {
			return null
		}
	},
	removeItem(key) {
		try {
			resolve()?.removeItem(key)
		} catch {
			// ignore
		}
	},
	setItem(key, value) {
		try {
			resolve()?.setItem(key, value)
		} catch {
			// ignore
		}
	},
})

const safeLocalStorage = makeSafeStorage(() =>
	typeof localStorage !== "undefined" ? localStorage : undefined,
)

const safeSessionStorage = makeSafeStorage(() =>
	typeof sessionStorage !== "undefined" ? sessionStorage : undefined,
)

export const safeJSONLocalStorage = <T>() => createJSONStorage<T>(() => safeLocalStorage)
export const safeJSONSessionStorage = <T>() => createJSONStorage<T>(() => safeSessionStorage)

export { safeLocalStorage, safeSessionStorage }
